/** Operator of the DineSpot service (UK company details for legal pages and footers). */
export const OPERATOR_LEGAL_NAME = 'HOWDENORDERS LIMITED';
export const OPERATOR_COMPANY_NUMBER = '13892025';
export const OPERATOR_REGISTERED_OFFICE =
  '2nd Floor College House, 17 King Edwards Road, Ruislip, London, United Kingdom, HA4 7AE';

export const PRODUCT_NAME = 'DineSpot';
